import { useQuery } from '@tanstack/react-query';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

export const useDomainsEntities = () => {
  const catalogApi = useApi(catalogApiRef);

  return useQuery(
    ['domainEntities'],
    async () => {
      return catalogApi.getEntities({
        filter: { kind: ['Domain'] },
      });
    },
    {
      staleTime: 5 * 60 * 1000, // Cache the result for 5 minutes
    },
  );
};
